import { createAction } from "@reduxjs/toolkit";

import axios from "axios";
import { takeEvery, call, put } from "redux-saga/effects";
import {
  ADD_ASSET_TO_STREAM,
  ADD_ASSET_TO_STREAM_SUCCEDDED,
  ADD_ASSET_TO_STREAM_FAILED,
  FETCHING_STREAMS_FAILED,
  FETCHING_STREAMS_REQUEST,
  FETCHING_STREAMS_SUCCEEDED,
  STREAM_UPDATE_PROPERTY,
  CREATING_GROUP_IN_STREAM,
  CREATING_GROUP_IN_STREAM_SUCCEEDED,
  CREATING_GROUP_IN_STREAM_FAILED,
  RECORDING_STREAMED_VIEW,
  RECORDING_STREAM_VIEWED_SUCCEEDED,
  RECORDING_STREAM_VIEWED_FAILED
} from "./actionTypes";
import buildUrl from "build-url-ts";
import { AddAssetToStream, AddAssetToStreamFailed, AddAssetToStreamSucceeded, CreateGroup, CreateGroupFailed, CreateGroupSucceeded, FetchStreamsErrorResponse, FetchStreamsResponse, UpdateStreamPropertyRequest } from "src/types/streams";


import { DELETING_ASSET_FROM_STREAM_FAILED, DELETING_ASSET_FROM_STREAM_REQUEST, DELETING_ASSET_FROM_STREAM_SUCCEEDED, DELETING_STREAM_FAILED, DELETING_STREAM_REQUEST, DELETING_STREAM_SUCCEEDED, FETCHING_STREAM_ANALYTICS_FAILED, FETCHING_STREAM_ANALYTICS_REQUEST, FETCHING_STREAM_ANALYTICS_SUCCEEDED, FETCHING_STREAM_CHILDREN_FAILED, FETCHING_STREAM_CHILDREN_REQUEST, FETCHING_STREAM_CHILDREN_SUCCEEDED, FETCHING_STREAM_FAILED, FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_USER_ACCESS, FETCHING_USER_ACCESS_FAILED, FETCING_USER_ACCESS_SUCCEEDED, SORTING_STREAM, UPDATING_STREAM_FAILED, UPDATING_STREAM_REQUEST, UPDATING_STREAM_SUCCEEDED } from "./actionTypes";
import { DeleteAssetFromStream, DeleteAssetFromStreamFailed, DeleteAssetFromStreamSucceeded, DeleteStreamError, DeleteStreamRequest, DeleteStreamResponse, FetchStreamAnalytics, FetchStreamAnalyticsError, FetchStreamAnalyticsResponse, FetchStreamChildrenError, FetchStreamChildrenRequest, FetchStreamChildrenResponse, FetchStreamError, FetchStreamRequest, FetchStreamResponse, SortStreamRequest, UpdateStreamError, UpdateStreamRequest, UpdateStreamResponse, RecordingStreamViewed, RecordingStreamViewedSucceeded, RecordingStreamViewedFailed } from "../../types/streams";

// eslint-disable-next-line no-undef
const apiUrl = `${process.env.REACT_APP_API_URL}`;
const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const STREAMS_BASE_URL_v1 = `${apiUrl}/api/2.1/streams`;
const STREAMS_BASE_URL_V2 = `${apiUrl}/api/2.2/streams`;

export const fetchStreams = createAction<void>(FETCHING_STREAMS_REQUEST);
const fetchingStreamsSucceeded = createAction<FetchStreamsResponse>(FETCHING_STREAMS_SUCCEEDED);
const fetchingStreamsFailed = createAction<FetchStreamsErrorResponse>(FETCHING_STREAMS_FAILED);

const fetchStreamsSaga = function* (): any {
  const url = buildUrl(apiUrl, {
    path: '/api/2.0/streams/hub',
  });

  const fetchStreamsAPI = () => {
    return axios({
      method: "GET",
      url: url
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamsAPI);
    yield put(fetchingStreamsSucceeded({response: response}));
  } catch (error) {
    yield put(fetchingStreamsFailed({error: error}));
  }
};

//fetch stream
export const fetchStream = createAction<FetchStreamRequest>(FETCHING_STREAM_REQUEST);

const fetchingStreamSucceeded = createAction<FetchStreamResponse>(
  FETCHING_STREAM_SUCCEEDED
);

const fetchingStreamFailed = createAction<FetchStreamError>(
  FETCHING_STREAM_FAILED
);

const fetchStreamSaga = function* (
  action: ReturnType<typeof fetchStream>,
): any {

  const id = action.payload.id;

  const url = new URL(`${STREAMS_BASE_URL_v1}/${id}`);

  const fetchStreamsAPI = () => {
    return axios({
      method: "GET",
      url: url.toString()
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamsAPI);
    yield put(fetchingStreamSucceeded({stream: response}));
  } catch (error) {
    yield put(fetchingStreamFailed({id, error}));
  }
};

//fetch stream children
export const fetchStreamChildren = createAction<FetchStreamChildrenRequest>(FETCHING_STREAM_CHILDREN_REQUEST);

const fetchingStreamChildrenSucceeded = createAction<FetchStreamChildrenResponse>(
  FETCHING_STREAM_CHILDREN_SUCCEEDED
);

const fetchingStreamChildrenFailed = createAction<FetchStreamChildrenError>(
  FETCHING_STREAM_CHILDREN_FAILED
);

const fetchStreamChildrenSaga = function* (
  action: ReturnType<typeof fetchStreamChildren>,
): any {
  const id = action.payload.id;
  let sort = action.payload.sort;
  const page = action.payload.page;
  const limit = action.payload.limit;

  const url = new URL(`${STREAMS_BASE_URL_V2}/${id}/children`);

  if (!sort.order || !sort.type) {
    sort = {
      order: 'ASC',
      type: 'name'
    }
  }

  const params = {
    page,
    limit,
    sort: sort.order,
    type: sort.type
  }

  const fetchStreamChildrenAPI = () => {
    return axios({
      method: "GET",
      url: url.toString(),
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamChildrenAPI);
    const payload = {
      children: response,
      id: id,
      sort: sort
    }
    yield put(fetchingStreamChildrenSucceeded(payload));
  } catch (error) {
    yield put(fetchingStreamChildrenFailed({id, error}));
  }
};

//fetch stream analytics
export const fetchStreamAnalytics = createAction<FetchStreamAnalytics>(FETCHING_STREAM_ANALYTICS_REQUEST);

const fetchingStreamAnalyticsSucceeded = createAction<FetchStreamAnalyticsResponse>(
  FETCHING_STREAM_ANALYTICS_SUCCEEDED
);

const fetchingStreamAnalyticsFailed = createAction<FetchStreamAnalyticsError>(
  FETCHING_STREAM_ANALYTICS_FAILED
);

const fetchStreamAnalyticsSaga = function* (
  action: ReturnType<typeof fetchStreamAnalytics>,
): any {
  const id = action.payload.id;

  const url = new URL(`${STREAMS_BASE_URL}/${id}/analytics`);

  const fetchStreamAnalyticsAPI = () => {
    return axios({
      method: "GET",
      url: url.toString()
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchStreamAnalyticsAPI);
    yield put(fetchingStreamAnalyticsSucceeded(response));
  } catch (error) {
    yield put(fetchingStreamAnalyticsFailed({id, error}));
  }
};

//delete stream
export const deleteStream = createAction<DeleteStreamRequest>(DELETING_STREAM_REQUEST);

const deleteStreamSucceeded = createAction<DeleteStreamResponse>(
  DELETING_STREAM_SUCCEEDED
);

const deleteStreamFailed = createAction<DeleteStreamError>(
  DELETING_STREAM_FAILED
);

const deleteStreamSaga = function* (
  action: ReturnType<typeof deleteStream>,
): any {
  const id = action.payload.id;
  const event = action.payload.event;

  const url = new URL(`${STREAMS_BASE_URL}/${id}`);

  const deleteStreamAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString()
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteStreamAPI);
    yield put(deleteStreamSucceeded({id}));
    event({streamName: response.name});
  } catch (error) {
    yield put(deleteStreamFailed({id, error}));
  }
};

//sort stream
export const sortStream = createAction<SortStreamRequest>(SORTING_STREAM);

const sortStreamSaga = function* (): any {

};

//delete asset from stream
export const deleteAssetFromStream = createAction<DeleteAssetFromStream>(DELETING_ASSET_FROM_STREAM_REQUEST);

const deleteAssetFromStreamSucceeded = createAction<DeleteAssetFromStreamSucceeded>(DELETING_ASSET_FROM_STREAM_SUCCEEDED);

const deleteAssetFromStreamFailed = createAction<DeleteAssetFromStreamFailed>(DELETING_ASSET_FROM_STREAM_FAILED);

const deleteAssetFromStreamSaga = function* (
  action: ReturnType<typeof deleteAssetFromStream>,
): any {

  const request = action.payload;
  const streamId = request.id;
  const assets = request.assets;
  const event = request.event;
  const sourceCta = request.sourceCta;

  const url = new URL(`${STREAMS_BASE_URL}/${streamId}/assets`);

  const deleteAssetFromStreamAPI = () => {
    return axios({
      method: "DELETE",
      url: url.toString(),
      data: assets
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteAssetFromStreamAPI);
    yield put(deleteAssetFromStreamSucceeded({response, streamId}));
    event({response: response, sourceCta: sourceCta});
  } catch (error) {
    yield put(deleteAssetFromStreamFailed({error, streamId}));
  }
};

//update stream
export const updateStream = createAction<UpdateStreamRequest>(UPDATING_STREAM_REQUEST);

const updateStreamSucceeded = createAction<UpdateStreamResponse>(UPDATING_STREAM_SUCCEEDED);

const updateStreamFailed = createAction<UpdateStreamError>(UPDATING_STREAM_FAILED);

const updateStreamSaga = function* (
  action: ReturnType<typeof updateStream>,
): any {
  const request = action.payload.request;

  const url = new URL(`${STREAMS_BASE_URL}/${request.id}`);

  const updateStreamAPI = () => {
    return axios({
      method: "PUT",
      url: url.toString(),
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateStreamAPI);
    yield put(updateStreamSucceeded({response, id: request.id}));
  } catch (error) {
    yield put(updateStreamFailed({error, id: request.id}));
  }
};

//update stream
export const updateStreamProperty = createAction<UpdateStreamPropertyRequest>(STREAM_UPDATE_PROPERTY);

//add asset to stream
export const addAssetToStream = createAction<AddAssetToStream>(ADD_ASSET_TO_STREAM);

const addAssetToStreamSucceeded = createAction<AddAssetToStreamSucceeded>(ADD_ASSET_TO_STREAM_SUCCEDDED);

const addAssetToStreamFailed = createAction<AddAssetToStreamFailed>(ADD_ASSET_TO_STREAM_FAILED);

const addAssetToStreamSaga = function* (
  action: ReturnType<typeof addAssetToStream>,
): any {
  const request = action.payload;

  const url = new URL(`${STREAMS_BASE_URL}/${request.streamId}/assets`);

  const addAssetToStreamAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: request.assets
    }).then((response) => response.data);
  };

  try {
    const response = yield call(addAssetToStreamAPI);
    yield put(addAssetToStreamSucceeded({assets: response, streamId: request.streamId}));
  } catch (error) {
    yield put(addAssetToStreamFailed({error, streamId: request.streamId}));
  }
};

//create group
export const createGroup = createAction<CreateGroup>(CREATING_GROUP_IN_STREAM);

const createGroupSucceeded = createAction<CreateGroupSucceeded>(CREATING_GROUP_IN_STREAM_SUCCEEDED);

const createGroupFailed = createAction<CreateGroupFailed>(CREATING_GROUP_IN_STREAM_FAILED);

const createGroupSaga = function* (
  action: ReturnType<typeof createGroup>,
): any {
  const request = action.payload;
  const upsert = false;

  const url = new URL(`${STREAMS_BASE_URL}/${request.streamId}/groups`);

  let param = {
    name : request.groupName,
    upsert: upsert
  }

  const createGroupAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      params: param
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createGroupAPI);
    yield put(createGroupSucceeded({group: response, streamId: request.streamId}));
  } catch (error) {
    yield put(createGroupFailed({error, streamId: request.streamId}));
  }
};

// stream view event
export const recordStreamViewed = createAction<RecordingStreamViewed>(RECORDING_STREAMED_VIEW);

const recordingStreamViewedSucceeded = createAction<RecordingStreamViewedSucceeded>(RECORDING_STREAM_VIEWED_SUCCEEDED);

const recordingStreamViewedFailed = createAction<RecordingStreamViewedFailed>(RECORDING_STREAM_VIEWED_FAILED);

const recordingStreamViewedSaga = function* (
  action: ReturnType<typeof recordStreamViewed>,
): any {
  const request = action.payload;

  const url = new URL(`${STREAMS_BASE_URL}/${request.id}/events`);

  const recordingStreamViewedAPI = () => {
    return axios({
      method: "POST",
      url: url.toString(),
      data: request.event
    }).then((response) => response.data);
  };

  try {
    const response = yield call(recordingStreamViewedAPI);
    yield put(recordingStreamViewedSucceeded);
  } catch (error) {
    yield put(recordingStreamViewedFailed);
  }
};


export default function* streamsSaga() {
  yield takeEvery(FETCHING_STREAMS_REQUEST, fetchStreamsSaga);
  yield takeEvery(FETCHING_STREAM_REQUEST, fetchStreamSaga);
  yield takeEvery(FETCHING_STREAM_CHILDREN_REQUEST, fetchStreamChildrenSaga);
  yield takeEvery(FETCHING_STREAM_ANALYTICS_REQUEST, fetchStreamAnalyticsSaga);
  yield takeEvery(DELETING_STREAM_REQUEST, deleteStreamSaga);
  yield takeEvery(SORTING_STREAM, sortStreamSaga);
  yield takeEvery(DELETING_ASSET_FROM_STREAM_REQUEST, deleteAssetFromStreamSaga);
  yield takeEvery(UPDATING_STREAM_REQUEST, updateStreamSaga);
  yield takeEvery(ADD_ASSET_TO_STREAM, addAssetToStreamSaga);
  yield takeEvery(CREATING_GROUP_IN_STREAM, createGroupSaga);
  yield takeEvery(RECORDING_STREAMED_VIEW, recordingStreamViewedSaga)
}
